import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ_ITEMS = [
	{
		id: "what-is-it",
		question: "What is a mate?",
		answer:
			"Agent that works like a colleague. You describe what needs doing. It does it. On schedule, without supervision. Not alerts. Actual work completed.",
	},
	{
		id: "actions",
		question: "What can it do?",
		answer:
			"Real work. Adds negative keywords to your Google Ads. Creates contacts in HubSpot. Sends emails (with your approval). Not reports.",
	},
	{
		id: "examples",
		question: "What do people use it for?",
		answer:
			"Pausing bad ad campaigns. Creating content briefs. Sending partnership outreach. Turning emails into tasks. Updating dashboards. The recurring stuff that never gets done.",
	},
	{
		id: "how-works",
		question: "How do I get started?",
		answer:
			"Connect your apps, describe what you want, set when it runs. No workflows to build. First task running in minutes.",
	},
	{
		id: "email",
		question: "Can I email tasks to my mate?",
		answer:
			"Yes. Each mate gets a unique email address. Send it a task, it does the work, and replies with the result. Works from any email client, phone, or forwarding rule.",
	},
	{
		id: "tools",
		question: "What apps does it work with?",
		answer:
			"Google Ads, Slack, Notion, Linear, HubSpot, Stripe, Gmail, Sheets, Semrush, Posthog. Adding more continuously.",
	},
	{
		id: "security",
		question: "Is my data safe?",
		answer:
			"Yes. We connect to your apps using OAuth. Your third-party credentials never touch our servers. You can disconnect apps or delete your account at any time.",
	},
];

export function LandingFaq() {
	return (
		<section className="mx-auto w-full max-w-3xl px-4 pt-4 pb-12">
			<h2 className="mb-8 text-2xl font-semibold tracking-tight">Frequently Asked Questions</h2>
			<Accordion type="single" collapsible className="w-full">
				{FAQ_ITEMS.map((item) => (
					<AccordionItem key={item.id} value={item.id}>
						<AccordionTrigger className="text-left">{item.question}</AccordionTrigger>
						<AccordionContent className="text-muted-foreground whitespace-pre-line">
							{item.answer}
						</AccordionContent>
					</AccordionItem>
				))}
			</Accordion>
		</section>
	);
}
